const WALLETS_AND_GROUPS_PATH: string = '/wallets-and-groups';
const CREATE_NEW_WALLETS_AND_GROUPS_PATH = `${WALLETS_AND_GROUPS_PATH}/new`;
const EDIT_NEW_WALLETS_AND_GROUPS_PATH = `${WALLETS_AND_GROUPS_PATH}/edit`;

export const WALLETS_AND_GROUPS_PATHS = {
    WALLETS_AND_GROUPS_PATH: WALLETS_AND_GROUPS_PATH,
    CREATE_NEW_WALLETS_AND_GROUPS_PATH: CREATE_NEW_WALLETS_AND_GROUPS_PATH,
    CREATE_NEW_USER_WALLET_PATH: `${CREATE_NEW_WALLETS_AND_GROUPS_PATH}/user-wallet`,
    CREATE_NEW_USER_GROUP_PATH: `${CREATE_NEW_WALLETS_AND_GROUPS_PATH}/user-group`,
    CREATE_NEW_SYSTEM_WALLET_PATH: `${CREATE_NEW_WALLETS_AND_GROUPS_PATH}/system-wallet`,
    EDIT_USER_WALLET_PATH: `${EDIT_NEW_WALLETS_AND_GROUPS_PATH}/user-wallet`,
    EDIT_USER_GROUP_PATH: `${EDIT_NEW_WALLETS_AND_GROUPS_PATH}/user-group`,
    EDIT_SYSTEM_WALLET_PATH: `${EDIT_NEW_WALLETS_AND_GROUPS_PATH}/system-wallet`,
};
